import React from 'react';
import {
  Badge,
  Button,
  Icons,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';

import { ITableFilterValue } from './Table.type';
import { FiltersContainer } from './style';

interface IRenderFiltersProps {
  handleClearFiltersOnClick: () => void;
  handleClearArrayFilter: (key: string, index: number) => void;
  handleClearFilter: (key: string) => void;
  filters: ITableFilterValue[];
}

const { Cross, TrashAltSolid } = Icons;

const RenderFilters = ({
  handleClearFiltersOnClick,
  handleClearArrayFilter,
  handleClearFilter,
  filters,
}: IRenderFiltersProps) => {
  const renderFilterBadge = (filter: ITableFilterValue) => {
    if (typeof filter.displayValue === 'object') {
      return filter.displayValue.map((item: string, index: number) => (
        <Badge key={item} size={Sizes.ExtraSmall} className='display-value'>
          {item}{' '}
          <Button
            data-testid={`clear-${item}-filter-button`}
            className='badge-button'
            size={Sizes.ExtraSmall}
            variant='transparent'
            icon={<Cross />}
            onClick={() => handleClearArrayFilter(filter.key, index)}
            aria-label={`Clear ${item} filter`}
          />
        </Badge>
      ));
    }

    return (
      <Badge size={Sizes.ExtraSmall} className='display-value'>
        {filter.displayValue ?? filter.value}
        <Button
          className='badge-button'
          size={Sizes.ExtraSmall}
          variant='transparent'
          icon={<Cross />}
          onClick={() => handleClearFilter(filter.key)}
          aria-label={`Clear ${filter.displayLabel} filter`}
        />
      </Badge>
    );
  };

  const renderFilters = () => (
    <FiltersContainer>
      {filters.map((filter) => (
        <div key={filter.key} className='filter'>
          <div className='display-label'>{filter.displayLabel}:</div>{' '}
          {renderFilterBadge(filter)}
        </div>
      ))}
      <div className='filter'>
        <Button
          size={Sizes.ExtraSmall}
          icon={<TrashAltSolid />}
          variant='transparent'
          onClick={handleClearFiltersOnClick}
        >
          Clear
        </Button>
      </div>
    </FiltersContainer>
  );

  return <>{renderFilters()}</>;
};

export default RenderFilters;
